export default __webpack_public_path__ + "static/21955-27bf81cc88b81fad13224d92711293da.jpg";